/**
 * src/engine/jobs/updateStatus.js
 *
 * Handler for state_logic operation: update_status
 *
 * Finds all entities of the given type where the condition applies
 * and updates their status field.
 *
 * Returns { changed: bool, summary: string, updatedIds: string[] }
 */

export function runUpdateStatus(actionConfig, matchedEntities, _state) {
  const { targetField = 'status', newValue } = actionConfig;

  const updatedIds = [];

  for (const entity of matchedEntities) {
    if (entity[targetField] !== newValue) {
      entity[targetField] = newValue;
      updatedIds.push(entity.id);
    }
  }

  const changed = updatedIds.length > 0;
  const summary = changed
    ? `Updated ${updatedIds.length} record(s) → ${targetField}="${newValue}"`
    : `No records needed updating (${targetField}="${newValue}" already set)`;

  return { changed, summary, updatedIds };
}
